<template>
   <div class="mfbox">
            <div class="mfbox__image">
              <img  :src="imageFile" />
            </div>
    </div>
</template>
<script>
export default {
    props: {
      imageFile:{
      type: Object,
      default: () => {},
    },

},
computed: {

  },
methods: {

  },
}
</script>
<style lang="">

</style>
